<template>
    <div class="cover-content table-wrapper">
        <!-- <high-search> -->
        <Form ref="formInline" :model="formInline" inline class="form-list" :label-width="100" label-position="right">
            <Row :gutter="16">
                <Col span="6">
                    <FormItem label="项目名称:" :label-width="78">
                        <Input v-model="formInline.projectName" placeholder="请输入项目名称"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="项目编号:">
                        <Input v-model="formInline.projectCode" placeholder="请输入项目编号"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="项目类型:">
                        <Select v-model="formInline.category" placeholder="请选择项目类型" filterable>
                            <Option value="01">房屋建筑工程</Option>
                            <Option value="02">市政公用工程</Option>
                            <Option value="99">其他</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="6" class="high-search">
                    <FormItem :label-width="0">
                        <Button type="primary" @click="handleQuery">搜索</Button>
                        <Button style="margin-left: 20px" @click="handleReset">重置</Button>
                        <span :class='open ? "search-open" : "search-close"' @click='open = !open'>{{open ? '收起' : '展开'}} <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'" /></span>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="16" v-show="open">
              <!-- <Col span="6">
                    <FormItem label="项目状态:" :label-width="78">
                        <Select v-model="formInline.prjStatus" placeholder="请选择项目状态" filterable>
                            <Option value="001">筹备</Option>
                            <Option value="002">立项</Option>
                            <Option value="003">在建</Option>
                            <Option value="004">完工</Option>
                            <Option value="005">停工</Option>
                        </Select>
                    </FormItem>
                </Col> -->
                <Col span="6">
                    <FormItem label="考勤时间:" :label-width="78">
                        <template>
                            <el-date-picker
                                class="marL"
                                v-model="formInline.startDate"
                                type="date"
                                :picker-options="pickerOptions"
                                placeholder="请选择一天" @change="timeChange"
                                >
                            </el-date-picker>
                        </template>
                        <!-- <DatePicker type="date" placeholder="请选择考勤开始时间" v-model="formInline.startDate" style="width: calc(50% - 6px);margin-right: 12px;" @on-change='handleStartDate' :options='{
                            disabledDate: disabledDateStart
                        }'></DatePicker>
                        <DatePicker type="date" placeholder="请选择考勤结束时间" v-model="formInline.endDate" style="width: calc(50% - 6px);" @on-change='handleEndDate' :options='{
                            disabledDate: disabledDateEnd
                        }'></DatePicker> -->
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="是否考勤:">
                        <Select v-model="formInline.isKq" placeholder="请选择是否考勤" filterable>
                            <Option value="是">是</Option>
                            <Option value="否">否</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="项目所在地:">
                        <!-- <Select v-model="formInline.areaCode" filterable transfer placeholder="请选择地区">
                            <Option v-for="(item,index) in area" :value="item.value" :key="index">{{ item.label }}</Option>
                        </Select> -->
                            <Input v-model="areaName" disabled></Input>
                    </FormItem>
                </Col>
                <Col span="6"  class="high-search">
                    <Button style="margin-bottom: 24px;" icon="ios-exit-outline" type="primary" @click="handleExport">导出</Button>
                </Col>
            </Row>
            <!-- <Row>
                
            </Row> -->
        </Form>
        <!-- </high-search> -->
        <div class='cover-table'>
            <Table border style="width: 100%;" :loading="loading" :columns="tableColumns" :data="tableData" highlight-row>
                <template slot-scope="{ row, index }" slot="action">
                    <span class="pointer" @click="handleDeal('projectDetail',row.id)">详情</span>
                </template>
            </Table>
            <Page class='page' :total="totalCount" :page-size="pageSize" :current="page" @on-change="changePage" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total transfer>
            </Page>
        </div>
    </div>
</template>
<style scoped>
 .marL{
       width:100%;
       height:32px;
   }
  .marL>>>.el-input__inner{
       display: inline-block;
       height:32px;
   }
   .marL>>>.el-icon-date{
       margin-left:-9px;
       font-size: 14px;
       /* margin-top:-8px; */

    color: #C0C4CC;
    float: left;
    line-height: 32px;

   }
   .marL>>>.el-range-separator{
       margin-top:-8px ;
       display: inline-block;
       width:16%;
   }
   .marL >>> .el-range__close-icon{
       margin-top:-8px;
   }
   .marL >>> .el-input__suffix .el-input__icon{
       height:32px;
       line-height: 32px;
   }
</style>
<script>
    import { mapState } from 'vuex';
    import tableMixin from '@/components/tableMixin';
    import {format} from "../../../utils/forMat";
    import dataTime from '@/components/dataTimeMixin';
    export default {
        mixins: [tableMixin,dataTime],
        data(){
            return {
                open: false,
                formInline:{
                    //areaCode: localStorage.getItem('tenantAreaCode'),// 地区
                    areaCode:this.$route.query.areaCode,
                    current: 1,
                    // endDate: "",// 结束时间
                    projectName: "",// 项目名称
                    size: 10,
                    // startDate: "",// 开始时间
                    projectCode: "",// 项目编号
                    category: "",// 类型
                    prjStatus: "003",// 项目状态
                    isKq: ""// 是否考勤:是,否
                },
                tableColumns:[
                    { title: '序号', type: 'index', width: 70, fixed: 'left', align: 'center' },
                    { title: '项目名称', key: 'name', minWidth: 210, tooltip: true },
                    { title: '项目编号', key: 'projectCode', minWidth:180, tooltip: true },
                    { title: '项目类型', key: 'category', minWidth: 180, tooltip: true },
                    { title: '项目属地', key: 'areaName', minWidth: 140, tooltip: true },
                    { title: '项目状态', key: 'prjStatus', minWidth: 100 },
                    { title: '建设单位', key: 'buildCorpName', minWidth: 210, tooltip: true },
                    { title: '监理单位', key: 'supervisingName', minWidth: 210, tooltip: true },
                    { title: '施工单位', key: 'contractorCorpName', minWidth: 210, tooltip: true },
                    // { title: '参建班组', key: 'teamName', minWidth: 210, tooltip: true },
                    { title: '在岗人数', key: 'personNum', align:'right', minWidth: 100 },
                    { title: '考勤日期', key: 'workDate', minWidth: 120 },
                    { title: '考勤人数', key: 'attendanceNum', align:'right', minWidth:100 },
                    { title: '出勤率', key: 'attendanceRate', align:'right', minWidth: 100 },
                    { title: '操作', slot: 'action', fixed: 'right', align: 'center', minWidth:100 }
                ],
                tableData: [],
                areaName:'',
            };
        },
        computed:{
            ...mapState(['navList','area','citys','areaCode'])
        },
        created(){
          this.areaName = this.$route.query.areaName;
        },
        mounted(){

        },
        watch: {
        },
        methods: {
            timeChange(val) {
                this.formInline.startDate = format(val,"yyyy-MM-dd");
                this.formInline.endDate = format(val,"yyyy-MM-dd");
            },
            disabledDateStart(val) {
                return new Date(this.formInline['endDate'] || '').getTime() < val.getTime()
            },
            disabledDateEnd(val) {
                return new Date(this.formInline['startDate'] || '').getTime() > val.getTime()
            },
            handleStartDate(val) {
                this.formInline['startDate'] = val
            },
            handleEndDate(val) {
                this.formInline['endDate'] = val
            },
            handleReset() {
                this.pageSize = 10
                this.page = 1
                this.formInline = {
                    //areaCode: localStorage.getItem('tenantAreaCode'),// 地区
                    areaCode:this.$route.query.areaCode,
                    current: 1,
                    endDate: "",// 结束时间
                    projectName: "",// 项目名称
                    size: 10,
                    startDate: "",// 开始时间
                    projectCode: "",// 项目编号
                    category: "",// 类型
                    prjStatus: "003",// 项目状态
                    isKq: ""// 是否考勤:是,否
                }
                this.getTableData()
            },
            //导出
            handleExport(){
                const { startDate, endDate, projectName, workerName, corpName, areaCode, projectCode, category, prjStatus, isKq } = this.formInline
                this.axios({
                    method: 'post',
                    url:'/worker/sx/projectcorpAttendance/export',
                    responseType:'arraybuffer',
                    data: {
                        startDate,
                        endDate,
                        projectName,
                        workerName,
                        corpName,
                        areaCode,
                        size: this.pageSize,
                        current: this.page, projectCode, category, prjStatus, isKq
                    },
                }).then( (response)=> {
                    this.common.download(response,'监管项目统计.xls','application/vnd.ms-excel');
                });
            },
            /*处理操作*/
            handleDeal(name, id){
                this.$router.push({
                    name: name,
                    query: {
                        projectId:id
                    }
                });
            },
            /*获取表格数据*/
            getTableData(){
                const { startDate, endDate, projectName, workerName, corpName, areaCode, projectCode, category, prjStatus, isKq } = this.formInline
                this.loading=true;
                this.axios({
                    method: 'post',
                    url: '/worker/sx/corpattendance/projects',
                    data: {
                        startDate,
                        endDate,
                        projectName,
                        workerName,
                        corpName,
                        areaCode: areaCode,
                        size: this.pageSize,
                        current: this.page, projectCode, category, prjStatus, isKq
                    }
                }).then( (response)=> {
                    this.loading=false;
                    if (response.data.success){
                        this.totalCount = response.data.data.total
                        this.tableData = response.data.data.records
                    }
                }).catch(()=> {
                    this.loading=false;
                });
            },
        }
    };
</script>
